import { DarkModeTwoTone, LightModeTwoTone, Logout } from "@mui/icons-material";
import { AppBar, AppBarProps, IconButton, Toolbar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { Dispatch, SetStateAction } from "react";
import { AuthContextProps, useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";

interface TitleBarProps extends AppBarProps {
  lightMode: boolean;
  setLightMode: Dispatch<SetStateAction<boolean>>;
}

const BASE_URL = process.env.REACT_APP_URL || "http://localhost:3000/";

const signOutRedirect = (auth: AuthContextProps) => {
  const clientId = "3d810ebiahqdulnov1u2ktvvj5";
  const logoutUri = BASE_URL;
  const cognitoDomain = "https://us-east-2jmt4tcpyv.auth.us-east-2.amazoncognito.com";

  auth.signoutSilent();

  window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};



const TitleBar: React.FC<TitleBarProps> = ({ lightMode, setLightMode }) => {
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} onClick={() => navigate('/')}>
            Product Security Dashboard
          </Typography>
          <IconButton onClick={() => setLightMode(!lightMode)}>
            {lightMode ? <DarkModeTwoTone /> : <LightModeTwoTone />}
          </IconButton>
          <IconButton onClick={() => signOutRedirect(auth)}>
            <Logout />
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default TitleBar;
